import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Container, Button, Card, Form } from "react-bootstrap";
import AuthHeader from "../../components/header/AuthHeader";
import { FaArrowRight } from "react-icons/fa";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { register } from "../../redux/actions/AuthUserActions";
import Loader from "../../components/loader/Loader";
import ReactFlagsSelect from "react-flags-select";
import PhoneInput from "react-phone-input-2";

function Register() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [countrySelected, setCountrySelected] = useState("");

  const schema = Yup.object({
    firstname: Yup.string().required("Prénom requis"),
    lastname: Yup.string().required("Nom requis"),
    country: Yup.string().required("Pays requis"),
    phone: Yup.string().required("Téléhone requis"),
    email: Yup.string().email("Email invalide").required("Email requis"),
    // password: Yup.string()
    //   .min(6, "Le mot de passe doit contenir au moins 6 caractères")
    //   .required("Mot de passe requis"),
    // confirmPassword: Yup.string()
    //   .oneOf(
    //     [Yup.ref("password"), null],
    //     "Les mots de passe doivent correspondre"
    //   )
    //   .required("Confirmation du mot de passe requise"),
  });

  const formik = useFormik({
    initialValues: {
      lastname: "",
      firstname: "",
      email: "",
      country: "",
      phone: "",
      // password: "",
      // confirmPassword: "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      setSubmitting(true);
      dispatch(register({ ...values, mobile: values.phone }, handleCallback));
    },
  });

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      Toast.fire({
        icon: "success",
        title: "Succès",
        text: message,
      });
      navigate("/login");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <>
      <AuthHeader />
      <Container
        fluid
        style={{
          backgroundColor: "#fff",
          paddingBottom: "40px",
          paddingLeft: "15px",
          paddingRight: "15px",
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Loader isLoading={submitting} />
        <Card
          style={{
            maxWidth: "500px",
            marginTop: "50px",
            padding: "30px 20px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: "18px",
            width: "100%",
          }}
        >
          <Card.Body>
            <h4
              className="mt-1 mb-4"
              style={{
                color: "#FF5500",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              INSCRIPTION
            </h4>

            <Form onSubmit={formik.handleSubmit} style={{ textAlign: "left" }}>
              {/* Nom et Prénom sur la même ligne */}
              <div className="row mb-3 g-3">
                <div className="col-md-6">
                  <Form.Group controlId="lastname">
                    <Form.Control
                      name="lastname"
                      placeholder="Nom"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.lastname}
                      isInvalid={
                        formik.touched.lastname && formik.errors.lastname
                      }
                      style={{
                        height: "45px",
                        borderRadius: "5px",
                        borderBlockColor: "#c4c4c4",
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.lastname}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group controlId="firstname">
                    <Form.Control
                      name="firstname"
                      placeholder="Prénom"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.firstname}
                      isInvalid={
                        formik.touched.firstname && formik.errors.firstname
                      }
                      style={{
                        height: "45px",
                        borderRadius: "5px",
                        borderBlockColor: "#c4c4c4",
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.firstname}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              {/* Email */}
              <Form.Group controlId="email" className="mb-3">
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  isInvalid={formik.touched.email && formik.errors.email}
                  style={{
                    height: "45px",
                    borderRadius: "5px",
                    borderBlockColor: "#c4c4c4",
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Pays et Numéro de téléphone sur la même ligne */}
              <div className="row mb-3 g-3">
                <div className="col-md-6">
                  <Form.Group controlId="country">
                    <ReactFlagsSelect
                      selected={countrySelected}
                      onSelect={(code) => {
                        formik.setFieldValue("country", code);
                        setCountrySelected(code);
                      }}
                      placeholder="Pays de résidence"
                      searchable
                      searchPlaceholder="Recherchez votre pays"
                      selectButtonClassName="w-100 custom-select"
                      className="custom-select"
                    />
                    {formik.errors.country && formik.touched.country && (
                      <div
                        className="text-danger"
                        style={{ textAlign: "left", fontSize: "14px" }}
                      >
                        {formik.errors.country}
                      </div>
                    )}
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <PhoneInput
                    country={formik.values.country.toLowerCase() || "cm"}
                    value=""
                    placeholder="Numéro de Téléphone"
                    onChange={(phone) => {
                      const formattedPhone = phone.startsWith("+")
                        ? phone
                        : `+${phone}`;
                      formik.setFieldValue("phone", formattedPhone);
                    }}
                    inputStyle={{
                      width: "100%",
                      height: "45px",
                      fontSize: "14px",
                    }}
                  />
                  {formik.errors.phone && formik.touched.phone && (
                    <div
                      className="text-danger"
                      style={{ textAlign: "left", fontSize: "14px" }}
                    >
                      {formik.errors.phone}
                    </div>
                  )}
                </div>
              </div>

              {/* Mot de passe */}
              {/* <Form.Group controlId="password" className="mb-3">
                <Form.Control
                  type="password"
                  name="password"
                  placeholder="Mot de passe"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                  isInvalid={formik.touched.password && formik.errors.password}
                  style={{
                    height: "45px",
                    borderRadius: "5px",
                    borderBlockColor: "#c4c4c4",
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.password}
                </Form.Control.Feedback>
              </Form.Group> */}

              {/* Confirmation de mot de passe */}
              {/* <Form.Group controlId="confirmPassword" className="mb-3">
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirmer le mot de passe"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.confirmPassword}
                  isInvalid={
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                  }
                  style={{
                    height: "45px",
                    borderRadius: "5px",
                    borderBlockColor: "#c4c4c4",
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.confirmPassword}
                </Form.Control.Feedback>
              </Form.Group> */}

              {/* Conditions générales */}
              <Form.Group controlId="termsAccepted" className="mb-4 mt-3">
                <Form.Check
                  type="checkbox"
                  label={
                    <span>
                      En cochant cette case, vous attestez avoir lu et accepté
                      les{" "}
                      <Link
                        to="/terms-and-conditions"
                        rel="noopener noreferrer"
                        style={{ color: "#FF5500" }}
                      >
                        Conditions Générales d'Utilisation
                      </Link>{" "}
                      et la{" "}
                      <Link
                        to="/privacy-policy"
                        rel="noopener noreferrer"
                        style={{ color: "#FF5500" }}
                      >
                        Politique de confidentialité
                      </Link>
                      .
                    </span>
                  }
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                />
              </Form.Group>

              {/* Bouton d'inscription */}
              <Button
                type="submit"
                variant="primary"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#051259",
                  color: "#fff",
                  fontWeight: "bold",
                  height: "45px",
                }}
                disabled={!formik.isValid || !termsAccepted}
              >
                S'inscrire <FaArrowRight style={{ marginLeft: "8px" }} />
              </Button>
            </Form>
          </Card.Body>
          <Card.Footer
            style={{
              backgroundColor: "#fff",
              textAlign: "center",
              fontSize: "14px",
              marginTop: "10px",
            }}
          >
            <span>
              Vous n'avez pas de compte?{" "}
              <a
                href="/login"
                style={{
                  color: "#FF5500",
                  textDecoration: "underline",
                }}
              >
                Se connecter
              </a>
              .
            </span>
          </Card.Footer>
        </Card>
      </Container>
    </>
  );
}

export default Register;
